<template>
  <div v-if="groups">
    <h2 class="h5">
      <strong>
        Coverage
      </strong>
    </h2>

    <div class="row">
      <div
        class="col-12 pb-2"
      >
        <button
          @click="groupSelected(gs)"
          v-for="(gs, index) in groups"
          :key="`g${index}`"
          class="btn btn-block btn-sm mt-1"
          :class="[selectedData === gs ? 'btn-secondary': 'btn-outline-secondary']"
        >
          {{ gs }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus';

export default {
  data() {
    return {
      selectedData: null,
    };
  },
  methods: {
    groupSelected(selectedData) {
      this.selectedData = selectedData;
      EventBus.$emit('coverageGroupSelected', this.selectedData);
    },
    layerClasses(index) {
      const classes = ['btn', 'btn-primary'];
      if (this.groups[index] === this.selectedData) {
        classes.push('active');
      }
      return classes;
    },
  },
  name: 'GroupSelector',
  props: {
    groups: {
      required: true,
      type: Array,
    },
    selected: {
      default: null,
      required: false,
      type: String,
    },
  },
  watch: {
    selected(newV) {
      this.selectedData = newV;
    },
  },
};
</script>

<style>
</style>
